import { AbstractControl } from "@angular/forms";

/**
 * Validate if the control isn't empty.
 * @param control Abstract control.
 * @returns Boolean or null.
 */
export function NotEmptyValidator(control: AbstractControl): { isEmpty: boolean; } | null {
  const value: string = control.value as string;
  
  return !value.trim().length ? { isEmpty: true } : null;
}

/**
 * Validate if the control has blank spaces.
 * @param control 
 * @returns Boolean or null.
 */
export function BlankSpaceValidator(control: AbstractControl): { isEmpty: boolean; } | null {
  const value: string = control.value as string;
  
  if(!value.length)
    return null;

  return !value.trim().length ? { isEmpty: true } : null;
}
